"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ClayPaginationWithBasicItems", {
  enumerable: true,
  get: function get() {
    return _PaginationWithBasicItems.ClayPaginationWithBasicItems;
  }
});
Object.defineProperty(exports, "Ellipsis", {
  enumerable: true,
  get: function get() {
    return _Ellipsis.Ellipsis;
  }
});
Object.defineProperty(exports, "Item", {
  enumerable: true,
  get: function get() {
    return _Item.Item;
  }
});
Object.defineProperty(exports, "Pagination", {
  enumerable: true,
  get: function get() {
    return _Pagination.Pagination;
  }
});
exports.default = void 0;
var _Pagination = require("./Pagination");
var _PaginationWithBasicItems = require("./PaginationWithBasicItems");
var _Ellipsis = require("./Ellipsis");
var _Item = require("./Item");
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var _default = exports.default = _Pagination.Pagination;